import React from 'react';
import { ReactQueryDevtools as RQDevTools } from '@tanstack/react-query-devtools';

import getReactQueryDevToolsInitialized from './utils/getReactQueryDevToolsInitialized';
import setReactQueryDevToolsInitialized from './utils/setReactQueryDevToolsInitialized';

const ReactQueryDevTools = props => {
  const isReactQueryDevToolsInitialized = getReactQueryDevToolsInitialized();

  if (!isReactQueryDevToolsInitialized) {
    setReactQueryDevToolsInitialized(true);
    return <RQDevTools {...props} />;
  }

  return null;
};

export default ReactQueryDevTools;
